<template>
    <div class="carBox">
        <el-card class="box-card">
            <div class="mainBody">
                <div class="searchBox" style="position: relative;left: -10px">
                    <div class="searchGroup">
                        <label>报警类型：</label>
                        <el-select v-model="search_Obj.f_device_type" clearable placeholder="请选择" style="width: 200px" @keyup.enter.native="doSearch">
                            <el-option v-for="item in enuObj('device_type2')" :key="'device_type2'+item.key" :label="item.title" :value="item.key"> </el-option>
                        </el-select>
                    </div>
                    <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
                    <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
                </div>
                <div class="dataBox">
                    <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                        <el-table-column type="selection" align="center" width="50"></el-table-column>
                        <el-table-column prop="device_type" label="设备种类" sortable="custom">
                            <template slot-scope="scope">
                                <span>{{ transEnu(scope.row.device_type, "device_type2") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="device_count" label="设备数量" sortable="custom"></el-table-column>
                        <el-table-column prop="device_count_need" label="所需设备数量" sortable="custom"></el-table-column>
                        <el-table-column prop="device_count_cha" label="数量差" sortable="custom"></el-table-column>
                        <el-table-column prop="device_count_use" label="投入使用数量" sortable="custom"></el-table-column>
                        <el-table-column label="操作" width="180" align="center">
                            <template slot-scope="scope">
                                <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageBox">
                    <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                </div>
                <Edit
                    width="600px"
                    :id="model_id"
                    :title="edit_title"
                    :isshow="editshow"
                    @on-close="closeEditDialog"
                    @on-save-ok="saveOk">
                </Edit>
                <Info
                    width="600px"
                    :id="model_id"
                    title="查看现场设备情况"
                    :isshow="infoshow"
                    @on-close="closeInfoDialog">
                </Info>
            </div>
        </el-card>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import listutil from "@/libs/listutil"

export default {
    name: 'deviceInfoList',
    mixins: [listutil],
    components: {Edit, Info, Btns, LabBtns},
    data() {
        return {
            m_name: '现场设备情况',
            menu_id: 3380,
            list_url: "/api/admin/deviceinfo/list",
            search_Obj: {
                f_device_type: '',
            },
            del_Obj:{
                url:'/api/admin/deviceinfo/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['device_type2'],
            sortData: {
                prop: 'order_index',
                order: 'ascending'
            },
        };
    },
    methods: {}
};
</script>